var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessIconForModal = function SvgSuccessIconForModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#19AF00",
    fillOpacity: 0.149,
    rx: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    x: 1,
    y: 1,
    stroke: "#19AF00",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    rx: 31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#19AF00",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M45.065 29.333a13.333 13.333 0 1 1-6.401-8.886M27.998 30.666l4 4 13.333-13.333"
  })));
};
export { SvgSuccessIconForModal as ReactComponent };
export default __webpack_public_path__ + "6b731d724ed29b0800f06854b1168a8a.svg";